import React, { useCallback, useEffect, useState } from "react";
import FormInputField from "../common-components/FormInputField";
import { StyledGrid } from "../../pages/incorporation/Incorporation";
import Grid from "@mui/material/Grid2";
import { useFormik } from "formik";
import { StyledTypographyLLc } from "../style/modalStyleLarge";
import UploadFileFieldNew from "../common-components/UploadFileFieldNew";
import { UploadIcon } from "../../assets/Icon/dashboredIcon";
import { PhoneIcon } from "../../assets/Icon/LlcForm";
import SelectInputField from "../common-components/SelectInputField";
import { useSelector } from "react-redux";
import { Typography, Box, CircularProgress } from "@mui/material";
import theme from "../../theme";
import CustomButton from "../common-components/CustomButton";
import DatePickerField from "../common-components/DatePickerField";
import UploadMultipleFile from "../common-components/UploadMultipleFile";
import { businessExpenses, personalIncomeFields } from "../../utils/constants";
import { CCorpMemberFormSchema } from "../../form-schema";
import TitleBar from "../common-components/TitleBar";
import { StyleDiv } from "../../pages/orderMember/singleMember";
import { StyledButton } from "../style/ititn/DeatilStyle";
import CopyModel from "./CopyModel";
import { useDispatch } from "react-redux";
import { getCountryList } from "../../stores/incorporation";
import {
  deleteUploadedDocument,
  getTaxFilingData,
  getTaxFilingDataById,
  uploadTaxFilingForm,
} from "../../stores/taxfiling";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Toast from "../common-components/Toast";
import { setToast } from "../../stores/toast/toastslice";
import BackPageButton from "../common-components/BackPageButton";

const CCorpMemberForm = () => {
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [einPreviews, setEinPreviews] = useState<string | null>(null);
  const [itinPreviews, setItinPreviews] = useState<string[]>([]);
  const [companyDocPreviews, setCompanyDocPreviews] = useState<string[]>([]);
  const [companyDocuments, setCompanyDocuments] = useState<any[]>([]);
  const [einDocuments, setEinDocuments] = useState<any[]>([]);
  const [itinDocuments, setItinDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isFileDeleted, setIsFileDeleted] = useState(false);
  const { id: ID } = useParams();
  console.log(ID, "ID");
  const location = useLocation();
  const isReturn = location.state?.isReturn;
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const navigate = useNavigate();
  const { taxfillingOrderList, taxFilingDataReview } = useSelector(
    (state: any) => state.taxfiling,
  );
  const fetchListOrder = taxfillingOrderList?.tax_filing_files_list || [];
  // const taxFilingId = fetchListOrder.length > 0 ? fetchListOrder[0]?.id : null;
  const taxFilingId =
    taxFilingDataReview?.tax_filing_file?.id ||
    (fetchListOrder?.length ? fetchListOrder[0]?.id : null);

  const taxFilingOrderId =
    taxFilingDataReview?.tax_filing_file?.order_item_id ||
    (fetchListOrder?.length ? fetchListOrder[0]?.order_item_id : null);
  const tsxfillingData =
    fetchListOrder?.length > 1
      ? taxFilingDataReview?.tax_filing_file?.file_data
      : fetchListOrder[0]?.file_data;
  console.log(taxFilingDataReview?.documents_by_type, "ccrop");
  const id = ID || taxFilingId;
  const [isTaxModalOpen, setIsTaxModalOpen] = useState(false);
  const { countryList } = useSelector((store: any) => store.incorporation);
  const dispatch = useDispatch();
  useEffect(() => {
    if (countryList.length === 0) {
      dispatch<any>(getCountryList({}));
    }
  }, []);
  const getTaxFilingList = async () => {
    // setLoading(true);
    const payload = {
      offset: 0,
      limit: 10,
    };
    const result = await dispatch<any>(getTaxFilingData(payload));
    console.log(result?.payload, "result?.payload?.data");
    if (
      fetchListOrder?.length > 0 &&
      !isReturn &&
      !fetchListOrder[0]?.save_as_draft
    ) {
      if (fetchListOrder[0]?.step === 1) {
        navigate(`/tools/tax-filing/review/${taxFilingId}`, {
          state: taxFilingId,
        });
      }
    }
    // setLoading(false);
  };
  useEffect(() => {
    getTaxFilingList();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearInterval(timeout);
  }, []);

  const getTaxFilingListId = useCallback(async () => {
    if (!id) return;
    const payload = {
      tax_filing_file_id: id || taxFilingId,
    };
    await dispatch<any>(getTaxFilingDataById(payload)).then(
      async (res: any) => {
        if (res?.payload?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                res?.payload?.data?.message ||
                (typeof res?.payload?.data?.message === "string" &&
                  res?.payload?.data?.message) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            navigate("/tools/tax-filing");
          }, 2000);

          return () => clearTimeout(timeout);
        }
        setLoading(false);
      },
    );
  }, [dispatch, id]);
  useEffect(() => {
    getTaxFilingListId();
  }, [id]);
  const handleTaxModalClose = () => {
    setIsTaxModalOpen(false);
  };
  // Populate form with fetchListOrder data
  // console.log(tsxfillingData?.phone_number,"tsxfillingData");
  useEffect(() => {
    // console.log(tsxfillingData,"tsxfillingData");
    if (tsxfillingData) {
      const data = tsxfillingData;
      const documents =
        fetchListOrder?.length > 1
          ? taxFilingDataReview?.documents_by_type
          : fetchListOrder[0]?.documents;
      console.log(data, "data");
      console.log(tsxfillingData, "documentseytry");
      console.log("=== FORM INITIALIZATION DEBUG ===");
      console.log("fetchListOrder:", fetchListOrder);
      console.log("documents:", documents);
      console.log("documents?.company:", documents?.company);
      console.log("documents?.ein:", documents?.ein);
      console.log("documents?.itin:", documents?.itin);

      formik.setValues({
        // Personal Information
        name_surname: data?.name_surname || "",
        email: data.email || "",
        date_of_birth: data.date_of_birth || "",
        phone_number: data.phone_number || data.phone || "",
        country_code: data.country_code || "",
        country: data.country || "",

        // Business Details
        additional_members: data.additional_members || "",
        partnership_structure: data.partnership_structure || "",
        business_address: data.business_address || "",
        nature_of_business: data.nature_of_business || "",
        // ein: data.ein || '',
        // itin: data.itin || '',

        // File uploads (keep as null, files need to be re-uploaded)

        passport_scan:
          (taxFilingDataReview?.tax_filing_file as any)?.passport ||
          taxFilingDataReview?.documents_by_type?.passport ||
          (fetchListOrder?.passport ?? null),
        company_formation_document: documents?.company || [],
        ein_document: documents?.ein || [],
        itin_document: documents?.itin || [],

        // Business Income
        gross_income: data.gross_income || "",
        amount_returns: data.amount_returns || "",
        cost_of_goods_sold: data.cost_of_goods_sold || "",

        // Business Expenses
        advertising: data.advertising || "",
        commissions_fees: data.commissions_fees || "",
        contract_labor: data.contract_labor || "",
        insurance: data.insurance || "",
        interest_bank: data.interest_bank || "",
        legal_professional: data.legal_professional || "",
        office_expenses: data.office_expenses || "",
        pension_profit_sharing: data.pension_profit_sharing || "",
        rent_lease_vehicles: data.rent_lease_vehicles || "",
        repairs_maintenance: data.repairs_maintenance || "",
        supplies_materials: data.supplies_materials || "",
        supplies_stationary: data.supplies_stationary || "",
        taxes_licenses: data.taxes_licenses || "",
        travel_meals: data.travel_meals || "",
        utilities: data.utilities || "",
        wages: data.wages || "",
        other_business: data.other_business || "",

        // Personal Income
        personal_gross_income: data.personal_gross_income || "",
        interest_income: data.interest_income || "",
        tax_exempt_interest: data.tax_exempt_interest || "",
        qualified_dividends: data.qualified_dividends || "",
        taxable_refunds: data.taxable_refunds || "",
        scholarship_fellowship_grants: data.scholarship_fellowship_grants || "",
        capital_gain_loss: data.capital_gain_loss || "",
        other_gains_losses: data.other_gains_losses || "",
        ira_distributions: data.ira_distributions || "",
        pensions_annuities: data.pensions_annuities || "",
        farm_income_loss: data.farm_income_loss || "",
        unemployment_compensation: data.unemployment_compensation || "",
        other_income: data.other_income || "",

        // Additional Description
        additional_description: data.additional_description || "",
      });
      // console.log(formik.values,"===========formik.values");

      // Handle file previews for existing documents from the documents object
      if (documents?.company && Array.isArray(documents.company)) {
        // Set the actual document objects with IDs
        setCompanyDocuments(documents.company);

        const companyDocUrls = documents.company.map(
          (doc: any) => doc.document_file_url,
        );
        setCompanyDocPreviews(companyDocUrls);
        formik.setFieldValue("company_formation_document", companyDocUrls);
        console.log("Company documents:", companyDocUrls);
      }

      if (documents?.ein && Array.isArray(documents.ein)) {
        // Set the actual document objects with IDs
        setEinDocuments(documents.ein);

        const einDocUrls = documents.ein.map(
          (doc: any) => doc.document_file_url,
        );
        setEinPreviews(einDocUrls);
        formik.setFieldValue("ein_document", einDocUrls);
        console.log("EIN documents:", einDocUrls);
      }

      if (documents?.itin && Array.isArray(documents.itin)) {
        // Set the actual document objects with IDs
        setItinDocuments(documents.itin);

        const itinDocUrls = documents.itin.map(
          (doc: any) => doc.document_file_url,
        );
        setItinPreviews(itinDocUrls);
        console.log("ITIN documents:", itinDocUrls);
      }

      // Handle passport preview if available
      if ((taxFilingDataReview?.tax_filing_file as any)?.passport) {
        setFilePreview((taxFilingDataReview?.tax_filing_file as any).passport);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchListOrder, navigate, tsxfillingData]);
  const memberFormCCrophandling = async (
    values: any,
    saveAsDraft: boolean = true,
    isDraft: boolean = false,
  ) => {
    console.log(
      "memberFormCCrophandling called with values:",
      values,
      "saveAsDraft:",
      saveAsDraft,
    );
    if (saveAsDraft) {
      setIsSavingDraft(true);
    } else {
      setLoading(true);
    }
    const formData = new FormData();

    // Create a copy of values to modify for file_data (JSON string)
    const formDataForJson = { ...values };

    // Remove file fields from the JSON payload, as they are sent separately
    delete formDataForJson.passport_copy;
    delete formDataForJson.company_formation_document;
    delete formDataForJson.ein_document;
    delete formDataForJson.itin_document;

    // Append standard fields to FormData (as strings)
    formData.append("tax_filing_file_id", id);
    formData.append("step", isDraft ? "0" : "1");
    formData.append("save_as_draft", saveAsDraft ? "true" : "false");

    // Append the JSON string of the remaining form data
    formData.append("file_data", JSON.stringify(formDataForJson));

    // Debug: Log file information before processing
    console.log("=== FILE DEBUGGING ===");
    console.log(
      "values.passport_copy:",
      values.passport_copy,
      "Type:",
      typeof values.passport_copy,
    );
    console.log(
      "values.company_formation_document:",
      values.company_formation_document,
      "Type:",
      typeof values.company_formation_document,
      "IsArray:",
      Array.isArray(values.company_formation_document),
    );
    console.log(
      "values.ein_document:",
      values.ein_document,
      "Type:",
      typeof values.ein_document,
      "IsArray:",
      Array.isArray(values.ein_document),
    );
    console.log(
      "values.itin_document:",
      values.itin_document,
      "Type:",
      typeof values.itin_document,
      "IsArray:",
      Array.isArray(values.itin_document),
    );

    // Handle passport (can be File or string)
    if (values.passport_scan instanceof File) {
      console.log("Adding passport file:", values.passport_scan.name);
      formData.append("passport", values.passport_scan);
    } else if (typeof values.passport_scan === "string") {
      console.log("Adding passport string URL:", values.passport_scan);
      formData.append("passport_string", values.passport_scan);
    } else {
      console.log("No valid passport_scan found");
    }

    // Handle company documents (can be array of Files or array of { document_file_url: string })
    if (Array.isArray(values.company_formation_document)) {
      console.log(
        "Processing company_formation_document array with",
        values.company_formation_document.length,
        "items",
      );

      values.company_formation_document.forEach((item: any, index: number) => {
        // If it's a File
        if (item instanceof File) {
          console.log(`Adding company_formation_document (File): ${item.name}`);
          formData.append("company_formation_document", item);
        }
        // If it's an object with document_file_url
        else if (item && typeof item === "object" && item.document_file_url) {
          console.log(
            `Adding company_formation_document (URL string): ${item.document_file_url}`,
          );
          formData.append(
            "company_formation_document_string",
            item.document_file_url,
          );
        }
        // If it's a plain string
        else if (typeof item === "string") {
          console.log(`Adding company_formation_document (string): ${item}`);
          formData.append("company_formation_document_string", item);
        }
      });
    } else {
      console.log("No company_formation_document found or not an array");
    }

    // Handle EIN (single File or array with File/string)
    if (values.ein_document) {
      if (values.ein_document instanceof File) {
        console.log("Adding EIN document (File):", values.ein_document.name);
        formData.append("ein_document", values.ein_document);
      } else if (Array.isArray(values.ein_document)) {
        const firstItem = values.ein_document[0];
        if (firstItem instanceof File) {
          console.log(`Adding EIN document (first File): ${firstItem.name}`);
          formData.append("ein_document", firstItem);
        } else if (
          firstItem &&
          typeof firstItem === "object" &&
          firstItem.document_file_url
        ) {
          console.log(
            `Adding EIN document (URL string): ${firstItem.document_file_url}`,
          );
          formData.append("ein_document_string", firstItem.document_file_url);
        } else if (typeof firstItem === "string") {
          console.log("Adding EIN document (string):", firstItem);
          formData.append("ein_document_string", firstItem);
        }
      } else if (typeof values.ein_document === "string") {
        console.log("Adding EIN document (string):", values.ein_document);
        formData.append("ein_document_string", values.ein_document);
      }
    } else {
      console.log("No EIN document found");
    }

    // Handle ITIN documents (array of Files or array of { document_file_url: string })
    if (Array.isArray(values.itin_document)) {
      console.log(
        "Processing itin_document array with",
        values.itin_document.length,
        "items",
      );

      values.itin_document.forEach((item: any, index: number) => {
        if (item instanceof File) {
          console.log(`Adding ITIN document (File): ${item.name}`);
          formData.append("itin_document", item);
        } else if (item && typeof item === "object" && item.document_file_url) {
          console.log(`Adding ITIN document (URL): ${item.document_file_url}`);
          formData.append("itin_document_string", item.document_file_url);
        } else if (typeof item === "string") {
          console.log(`Adding ITIN document (string): ${item}`);
          formData.append("itin_document_string", item);
        }
      });
    } else {
      console.log("No ITIN documents found or not an array");
    }

    // Debug: Log FormData contents
    console.log("=== FORMDATA CONTENTS ===");
    const formDataEntries = Array.from(formData.entries());
    formDataEntries.forEach((pair) => {
      console.log(
        pair[0] +
          ": " +
          (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]),
      );
    });

    console.log("FormData created, about to dispatch API call");
    const result = await dispatch<any>(uploadTaxFilingForm(formData));
    // Reset loaders immediately after API call
    if (saveAsDraft) {
      setIsSavingDraft(false);
    } else {
      setLoading(false);
    }
    if (result?.payload?.status === 1) {
      if (isDraft) {
        dispatch<any>(
          setToast({
            message: "Data is saved as draft!",
            type: "success",
            title: "Success",
            onClose: () => {},
          }),
        );
        return;
      }
      if (result?.type?.includes("rejected")) {
        dispatch<any>(
          setToast({
            message: result?.payload?.data?.message || "Something went wrong",
            type: "error",
            title: "Error",
            onClose: () => {},
          }),
        );

        return;
      }
      if (fetchListOrder?.length === 1 && isDraft) {
        // Show success message for draft save
        dispatch<any>(
          setToast({
            message: "Data is saved as draft!",
            type: "success",
            title: "Success",
            onClose: () => {},
          }),
        );

        // Don't reload data to prevent form from resetting
        // User can refresh page manually if they want to see updated draft
      } else if (fetchListOrder?.length > 1 && isDraft) {
        navigate("/tools/tax-filing/list");
      } else {
        navigate(`/tools/tax-filing/review-ccrop/${id}`, {
          state: {
            taxFilingId: id,
            formData: values,
            documents: {
              company: values.company_formation_document,
              ein: values.ein_document,
              itin: values.itin_document,
            },
          },
        });
      }
    }
  };

  const formik: any = useFormik({
    initialValues: {
      // Personal Information
      name_surname: "",
      email: "",
      date_of_birth: "",
      phone_number: "",
      country: "",

      // Business Details
      additional_members: "",
      partnership_structure: "",
      business_address: "",
      nature_of_business: "",

      // File uploads
      passport_scan: "",
      company_formation_document: [],
      ein_document: "",
      itin_document: [],
      passport_scan_string: "",
      ein_document_string: "",
      itin_document_string: "",
      company_formation_document_string: "",

      // Business Income
      gross_income: "",
      amount_returns: "",
      cost_of_goods_sold: "",

      // Business Expenses
      advertising: "",
      commissions_fees: "",
      contract_labor: "",
      insurance: "",
      interest_bank: "",
      legal_professional: "",
      office_expenses: "",
      pension_profit_sharing: "",
      rent_lease_vehicles: "",
      repairs_maintenance: "",
      supplies_materials: "",
      supplies_stationary: "",
      country_code: "",
      taxes_licenses: "",
      travel_meals: "",
      utilities: "",
      wages: "",
      other_business: "",

      // Personal Income
      personal_gross_income: "",
      interest_income: "",
      tax_exempt_interest: "",
      qualified_dividends: "",
      taxable_refunds: "",
      scholarship_fellowship_grants: "",
      capital_gain_loss: "",
      other_gains_losses: "",
      ira_distributions: "",
      pensions_annuities: "",
      farm_income_loss: "",
      unemployment_compensation: "",
      other_income: "",

      // Additional Description
      // additional_description: "",
    },
    validationSchema: CCorpMemberFormSchema,
    onSubmit: (values) => {
      memberFormCCrophandling(values, true);
      // navigate("/tools/tax-filing/review");
    },
    validateOnChange: true,
    validateOnBlur: true,
  });
  console.log(formik.errors, "formik.error");
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    setPreview: (url: string | null) => void,
  ) => {
    const file = e.target.files?.[0] || null;
    formik.setFieldValue(fieldName, file);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setPreview(previewURL);
    } else {
      setPreview("");
    }
  };

  const handleSaveAsDraft = async () => {
    // Validate at least some fields are filled before saving as draft
    if (!formik.values.name_surname && !formik.values.email) {
      //  alert("Please fill in at least Name and Email before saving as draft");
      return;
    }
    try {
      // setIsSavingDraft(true);
      // Call the submission handler with saveAsDraft flag
      await memberFormCCrophandling(formik.values, true, true);
    } catch (error) {
      console.error("Error saving draft:", error);
      //  alert("Failed to save draft. Please try again.");
    } finally {
      // setIsSavingDraft(false);
    }
  };

  const handleDeleteUploadedDocument = async (
    index: number,
    documentType: "company" | "ein" | "itin",
  ) => {
    console.log("Document type:", documentType, index);
    let documents: any[] = [];
    let setDocuments: any;
    let setPreviews: any;

    // Determine which document array to use based on type
    if (documentType === "company") {
      documents = companyDocuments;
      setDocuments = setCompanyDocuments;
      setPreviews = setCompanyDocPreviews;
    } else if (documentType === "ein") {
      documents = einDocuments;
      setDocuments = setEinDocuments;
      setPreviews = setEinPreviews;
    } else if (documentType === "itin") {
      documents = itinDocuments;
      setDocuments = setItinDocuments;
      setPreviews = setItinPreviews;
    }

    console.log("Documents array:", documents);
    console.log("Documents length:", documents.length);
    console.log("Requested index:", index);

    // Get the actual document at this index
    const documentToDelete = documents[index];

    console.log("Document to delete:", documentToDelete);
    console.log("Has ID?", documentToDelete?.id);

    // Check if document has an ID (existing document from server)
    if (documentToDelete && documentToDelete.id) {
      console.log("Deleting document with ID:", documentToDelete.id);

      try {
        // Call API to delete
        setIsFileDeleted(true);
        const result = await dispatch<any>(
          deleteUploadedDocument(documentToDelete.id),
        );

        getTaxFilingListId(); // Refresh data after deletion
        if (result?.payload?.status === 1) {
          // Remove from local state
          const updatedDocuments = documents.filter((_, i) => i !== index);
          setDocuments(updatedDocuments);

          // Update previews
          const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
          setPreviews(
            updatedDocuments.map(
              (doc: any) => `${baseUrl}${doc.document_file_url}`,
            ),
          );

          dispatch<any>(
            setToast({
              message:
                result?.payload?.message || "Document deleted successfully!",
              type: "success",
              title: "Success",
            }),
          );
        }
      } catch (error) {
        console.error("Error deleting document:", error);
        dispatch<any>(
          setToast({
            message: "Failed to delete document. Please try again.",
            type: "error",
            title: "Error",
          }),
        );
      } finally {
        setIsFileDeleted(false);
      }
    } else {
      // Handle local state deletion (for newly uploaded files without ID)
      console.log("Deleting local document at index:", index);

      // Remove from local state
      const updatedDocuments = documents.filter((_, i) => i !== index);
      setDocuments(updatedDocuments);

      // Update previews
      const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
      setPreviews(
        updatedDocuments.map(
          (doc: any) => `${baseUrl}${doc.document_file_url || doc}`,
        ),
      );

      // Update formik values
      if (documentType === "company") {
        formik.setFieldValue("company_formation_document", updatedDocuments);
      } else if (documentType === "ein") {
        formik.setFieldValue("ein_document", updatedDocuments);
      } else if (documentType === "itin") {
        formik.setFieldValue("itin_document", updatedDocuments);
      }

      dispatch<any>(
        setToast({
          message: "Document removed successfully!",
          type: "success",
          title: "Success",
        }),
      );
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {fetchListOrder?.length > 1 && <BackPageButton title="Orders" />}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <TitleBar
          title="Intake Form for C-Corp Tax Filing Form"
          isSpan={true}
          spanText="Form1/1"
        />
        <StyleDiv>
          <StyledButton
            sx={{ marginRight: "10px" }}
            variant="outlined"
            color="primary"
            onClick={handleSaveAsDraft}
            disabled={isSavingDraft}
          >
            {isSavingDraft ? (
              <CircularProgress size={16} sx={{ color: "#fff" }} />
            ) : (
              "Save As Draft"
            )}
          </StyledButton>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={() => setIsTaxModalOpen(true)}
            // disabled={isSavingDraft}
          >
            Copy
          </StyledButton>
        </StyleDiv>
      </div>

      <Typography
        variant="body1"
        sx={{
          paddingY: "30px",
          color: "#666",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
        }}
      >
        Dear taxpayer, below is our simple tax filing form, if you need help
        with the form and if you don't know your options please don't hesitate
        to book a call here:
        <a
          href="https://calendly.com/theitin/30min?month=2024-11"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2977CC" }}
        >
          https://calendly.com/theitin/30min?month=2024-11
        </a>
        &nbsp; Please write your name and surname and TAX CONSULTATION on the
        description while booking.
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <StyledGrid
          container
          spacing={3}
          style={{ width: "100%", minHeight: "auto" }}
        >
          {/* PERSONAL INFORMATION */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              PERSONAL INFORMATION
            </StyledTypographyLLc>
            <FormInputField
              placeholder="Enter name and surname"
              formik={formik}
              name="name_surname"
              label="Name and Surname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Please upload your passport scan to prevent any mistakes for the
              correct information of your Full Name.
            </StyledTypographyLLc>
            <Box>
              <Typography
                sx={{
                  color: theme.palette.myCustomColor.dark,
                  marginBottom: "10px",
                }}
                variant="h4"
              >
                Passport Scan{" "}
                <span
                  style={{ color: "#666", fontSize: "12px", marginLeft: "3px" }}
                >
                  (optional)
                </span>
              </Typography>

              <UploadFileFieldNew
                title={""}
                icon={<UploadIcon />}
                name="passport_scan"
                formik={formik}
                handleFileChange={(e) =>
                  handleFileChange(e, "passport_scan", setFilePreview)
                }
                setFilePreview={setFilePreview}
                filePreview={filePreview}
                // showInstruction
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter email address"
              formik={formik}
              name="email"
              label="E-Mail"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <DatePickerField
              label="Date of Birth"
              placeholder="Enter date of birth"
              formik={formik}
              name="date_of_birth"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter phone number"
              formik={formik}
              name="phone_number"
              icon={<PhoneIcon />}
              isPhnNo={true}
              label="Phone"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Include Country Phone Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <SelectInputField
              formik={formik}
              placeholder="Select Country"
              label="Country"
              menuData={countryList}
              name="country"
              sendValue
            />
          </Grid>

          {/* BUSINESS DETAILS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              BUSINESS DETAILS
            </StyledTypographyLLc>
            <SelectInputField
              formik={formik}
              placeholder="Nothing selected"
              label="Number of additional members"
              menuData={[
                { id: 1, name: "0", value: "0" },
                { id: 2, name: "1", value: "1" },
                { id: 3, name: "2", value: "2" },
                { id: 4, name: "3", value: "3" },
                { id: 5, name: "4", value: "4" },
                { id: 6, name: "5+", value: "5+" },
              ]}
              name="additional_members"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <Box>
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                (Only if you have) Please explain below the partnership
                structure with the names and percentages, we will be contacting
                to get an additional information
              </Typography>
              <Typography
                sx={{ color: "#666", fontSize: "14px", marginTop: "4px" }}
                variant="body2"
              >
                optional
              </Typography>
              <FormInputField
                placeholder="Explain partnership structure with names and percentages if applicable"
                formik={formik}
                name="partnership_structure"
                label=""
                isMulti={true}
                rows={4}
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Company Documents
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload a file or drag and drop"
              name="company_formation_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={companyDocPreviews}
              setFilePreviews={setCompanyDocPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={isFileDeleted}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
              documents={companyDocuments}
              onDelete={(index) =>
                handleDeleteUploadedDocument(index, "company")
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter business address"
              formik={formik}
              name="business_address"
              label="Business Address"
              isMulti={true}
              rows={4}
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Include Zip Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Describe business clearly for NAICS code determination"
              formik={formik}
              name="nature_of_business"
              label="Nature of Business"
            />
          </Grid>

          {/* <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter EIN number"
              formik={formik}
              name="ein"
              label="EIN"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter ITIN number (optional)"
              formik={formik}
              name="itin"
              label="ITIN (optional)"
            />
          </Grid> */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              EIN Documents
            </StyledTypographyLLc>
            {/* <UploadMultipleFile
              title={""}
              placeholder="Upload a file or drag and drop"
              name="ein_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={einPreviews}
              setFilePreviews={setEinPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={false}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
            /> */}
            <UploadFileFieldNew
              title={""}
              icon={<UploadIcon />}
              name="ein_document"
              formik={formik}
              handleFileChange={(e) =>
                handleFileChange(e, "ein_document", setEinPreviews)
              }
              setFilePreview={setEinPreviews}
              filePreview={einPreviews}
              // showInstruction
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              ITIN (if you have one)
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload a file or drag and drop"
              name="itin_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={itinPreviews}
              setFilePreviews={setItinPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={isFileDeleted}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
              documents={itinDocuments}
              onDelete={(index) => handleDeleteUploadedDocument(index, "itin")}
            />
          </Grid>

          {/* BUSINESS INCOME DETAILS */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            BUSINESS INCOME DETAILS
          </StyledTypographyLLc>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter gross income"
              formik={formik}
              name="gross_income"
              label="Gross Income (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter amount of returns"
              formik={formik}
              name="amount_returns"
              label="Amount of Returns (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide amount for unpaid services. You can leave as ZERO
              if you do not have.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter cost of goods sold"
              formik={formik}
              name="cost_of_goods_sold"
              label="Amount of Cost of Goods Sold (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide amount paid for products bought during 2022, or
              zero if none. You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          {/* BUSINESS EXPENSE DETAILS */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            BUSINESS EXPENSES DETAILS
          </StyledTypographyLLc>
          {businessExpenses.map((expense, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={expense.name}
                label={expense.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {expense.hint}
              </Typography>
            </Grid>
          ))}

          {/* PERSONAL INCOME DETAILS */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            PERSONAL INCOME DETAILS (Please fill these only if you have any
            additional income besides your US business)
          </StyledTypographyLLc>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter personal gross income"
              formik={formik}
              name="personal_gross_income"
              label="Personal Gross Income (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              You can leave as 0 if you do not have.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter scholarship and fellowship grants"
              formik={formik}
              name="scholarship_fellowship_grants"
              label="Scholarship and Fellowship Grants (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              You can leave as 0 if you do not have.
            </Typography>
          </Grid>

          {personalIncomeFields.map((field, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={field.name}
                label={field.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {field.hint}
              </Typography>
            </Grid>
          ))}

          {/* ADDITIONAL DESCRIPTION */}
          {/* <Grid size={{ xs: 12, md: 12 }} sx={{ marginTop: "20px" }}>
            <FormInputField
              placeholder="Describe the section below or leave it empty"
              formik={formik}
              name="additional_description"
              label="Additional Description"
              isMulti={true}
              rows={6}
            />
          </Grid> */}

          {/* Submit Button */}
          <Grid
            size={{ xs: 12, md: 12 }}
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              btnTitle="Review"
              type="submit"
              loading={loading || isSavingDraft}
            />
          </Grid>
        </StyledGrid>
      </form>
      <CopyModel
        open={isTaxModalOpen}
        handleClose={handleTaxModalClose}
        taxfillingOrderList={fetchListOrder}
      />
    </>
  );
};

export default CCorpMemberForm;
